var styles = {"caption":"styles_caption__U8wGO p2 flex items-center","curation-icon":"styles_curation-icon__2Vr-M mr1","curationIcon":"styles_curation-icon__2Vr-M mr1","icon":"styles_icon__1mVXO mb2","plus-icon":"styles_plus-icon__2Dbqg","plusIcon":"styles_plus-icon__2Dbqg"};

export default styles;
//# sourceMappingURL=styles.css.js.map
